export default "/_next/static/images/86cbc5253beb7d45ab0dcfe1b73ffc9c.jpg";